<template>
  <el-dialog
      width="600px"
      :visible.sync="show"
      :before-close="handleClosePreview"
      :destroy-on-close="true"
      :append-to-body="true"
      :modal-append-to-body="true"
      center
      custom-class="dialogPreview d2-p-0"
  >
    <el-carousel
        :arrow="previewFileType=='word'?'never':'hover'"
        :autoplay="false"
        style="height: 500px;width: 100%;background-color: rgba(0,0,0,0.2)">
<!--      <div class="axj-preview-control">关闭</div>-->
      <el-carousel-item :key="x.url" class="axj-preview-item"
                        v-if="previewFileType=='image'" v-for="x in previewFiles" style="">
        <img :src="config.baseUrl+x.url"/>
      </el-carousel-item>
      <el-carousel-item :key="x.url" class="axj-preview-item" v-if="previewFileType=='word'" v-for="x in previewFiles" >
        <iframe style="width: 100%;height: 100%" :src="'https://view.officeapps.live.com/op/view.aspx?src='+config.baseUrl+x.url"/>
      </el-carousel-item>
    </el-carousel>
  </el-dialog>
</template>

<script>
export default {
  name: "axj-file-preview",
  methods:{
    handleClosePreview(){
      this.$emit("update:show-preview",false)
    }
  },
  data(){
    return{
      show:false,
      config:{
        baseUrl:'https://img.aixuejie.cn'
      },
    }
  },
  props:{
    showPreview:{
      type:Boolean,
      default:false
    },
    previewFileType:{
      type:String,
      default:"image"
    },
    previewFiles:{
      type:Array,
      default:res=>{return [
        {url:"https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2772061038,24226089&fm=26&gp=0.jpg"}
      ]}
    }
  },
  watch:{
    showPreview(v){
      this.show=v
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj-preview-item{
  height: 500px;
  width: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    max-height: 100%;
    max-width: 100%;
  }

}
.el-dialog{
}

.dialogPreview{
  .el-dialog__body{
    padding: 0px !important;
    .axj-preview-control{
      display: none;
    }
  }
  .el-dialog__body:hover{
    .axj-preview-control{
      display: flex;
      position: absolute;
      z-index: 1;
      background-color: #3a8ee6;
      width: 100%;
      height: 20px;
      top: 0
    }
  }

  background-color: rgba(0,0,0,0.2);
  height: 500px;
  width: 100%;
  .el-dialog__header{
    padding: 0;
    .el-dialog__title{
      visibility: hidden;
    }
    .el-dialog__headerbtn{
      visibility: hidden;
    }
  }
  .el-carousel__container{
    height: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/preview/index.vue